import React, { useEffect, useState } from 'react'
import {
  CCard,
  CCardBody,
  CFormSelect,
  CRow,
  CSmartTable,
  CTable,
  CTableBody,
  CTableHead,
} from '@coreui/react-pro'
import PlayerService from 'src/service/PlayerService'
const RoundPlayerStatsTab = (props) => {
  const [statsData, setStatsData] = useState([])
  const handlePlayer = (e) => {
    const playerId = e.target.value
    PlayerService.playerStatsByRound(playerId).then((res) => {
      if (res.success) {
        setStatsData(res.data)
      }
    })
  }
  return (
    <>
      <CCard className="mb-4">
        <CCardBody>
          <CRow>
            <CFormSelect
              aria-label="Select player"
              name="player"
              className={'form-control'}
              onChange={handlePlayer}
              id="player"
            >
              <option value={0}>Select Player</option>
              {props.playerList &&
                props.playerList.map((item, key) => (
                  <option value={item?.id} key={key}>
                    {item?.full_name}
                  </option>
                ))}
            </CFormSelect>
            <CTable className="main-table table innertable">
              <CTableHead color="dark">
                <tr>
                  <th>RD</th>
                  <th>FP</th>
                  <th>POS</th>
                  <th>SC</th>
                  <th>HW</th>
                  <th>AW</th>
                  <th>AL</th>
                  <th>HL</th>
                  <th>SSW</th>
                  <th>SSL</th>
                  <th>OWT</th>
                  <th>BWM</th>
                  <th>BLM</th>
                </tr>
              </CTableHead>
              <CTableBody>
                {statsData &&
                  statsData.map((item, key) => (
                    <tr key={key}>
                      <td>
                        <strong> {item.round}</strong>
                      </td>
                      <td>{item.sum_fp}</td>
                      <td>{item.position_name}</td>
                      <td>{item?.sum_sc}</td>
                      <td>{item?.sum_hw}</td>
                      <td>{item?.sum_aw}</td>
                      <td>{item?.sum_al}</td>
                      <td>{item?.sum_hl}</td>
                      <td>{item?.sum_ssw}</td>
                      <td>{item?.sum_ssls}</td>
                      <td>{item?.sum_owt}</td>
                      <td>{item?.sum_bwm}</td>
                      <td>{item?.sum_blm}</td>
                    </tr>
                  ))}
                {statsData.length === 0 && (
                  <tr>
                    <td colSpan={15}>No record yet available.</td>
                  </tr>
                )}
              </CTableBody>
            </CTable>
          </CRow>
        </CCardBody>
      </CCard>
    </>
  )
}

export default RoundPlayerStatsTab
